import React from 'react';

const ComparisonSummary = ({ metricName, currentValue, previousValue, formatter }) => {

  const formatValue = (value) => {
    if (value === null || value === undefined) return 'N/A';
    return formatter ? formatter(value) : value;
  };

  let percentageChange = null;
  let changeClass = 'text-gray-600';
  let changePrefix = '';

  if (previousValue !== null && previousValue !== undefined && currentValue !== null && currentValue !== undefined) {
    if (previousValue === 0) {
      percentageChange = currentValue > 0 ? '∞' : 'N/A'; // Infinite increase or N/A if both are 0
      if (currentValue > 0) changeClass = 'text-green-600';
    } else {
      const change = ((currentValue - previousValue) / Math.abs(previousValue)) * 100;
       // Avoid showing -0%
      percentageChange = Math.abs(change) < 0.01 ? '0%' : `${change.toFixed(0)}%`;

      if (change > 0) {
        changeClass = 'text-green-600';
        changePrefix = '+';
      } else if (change < 0) {
        changeClass = 'text-red-600';
         // Prefix is included in negative number
      }
    }
  } else {
    percentageChange = 'N/A'; // Not enough data to compare
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
      {/* Current Period */}
      <div className="bg-white p-4 rounded-lg border text-center shadow-sm">
        <div className="text-sm text-gray-500 uppercase tracking-wide">{metricName}</div>
        <div className="text-3xl font-bold text-indigo-600 my-2">
          {formatValue(currentValue)}
        </div>
        <div className="text-xs text-gray-400">Current Period</div>
      </div>

      {/* Previous Period */}
      <div className="bg-white p-4 rounded-lg border text-center shadow-sm">
        <div className="text-sm text-gray-500 uppercase tracking-wide">{metricName}</div>
        <div className="text-3xl font-bold text-gray-700 my-2">
          {formatValue(previousValue)}
        </div>
        <div className="text-xs text-gray-400">Previous Period</div>
      </div>

      {/* Percentage Change */}
      <div className={`bg-white p-4 rounded-lg border text-center shadow-sm flex flex-col justify-center ${changeClass}`}>
        <div className="text-sm text-gray-500 uppercase tracking-wide">Change</div>
        <div className={`text-3xl font-bold my-2`}>
          {changePrefix}{percentageChange}
        </div>
      </div>
    </div>
  );
};

export default ComparisonSummary;